/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import { cloneDeep } from 'lodash';

import { RECEIVED_COMMENTARY } from 'state/commentary/CommentaryActions';
import {
  combinations,
  ruleLookupMapAS,
  ruleLookupMapPGT,
  ruleLookupMapPRR,
  sampleSpace
} from 'services/Commentary';

const lookupFunctions = {
  activitySummary: ruleLookupMapAS,
  portfolioGrowth: ruleLookupMapPGT,
  rateOfReturn: ruleLookupMapPRR
};

const commentaryType = {
  templates: [],
  rules: [],
  rulesToTemplateLookup: {}
};

export const commentaryInitialState = {
  activitySummary: cloneDeep(commentaryType),
  portfolioGrowth: cloneDeep(commentaryType)
};

export const commentaryReducer = (state = [], action) => {
  if (action.type === RECEIVED_COMMENTARY) {
    let commentary = cloneDeep(state);
    let commentaryData = action.commentary;
    let lookupFunction = lookupFunctions[commentaryData.type];
    commentary[commentaryData.type] = {
      templates: commentaryData.templates,
      rules: commentaryData.rules,
      rulesToTemplateLookup: lookupFunction(commentaryData.rules),
      allPossibleLookupIndices: combinations(sampleSpace[commentaryData.type])
    };

    return commentary;
  }
  return state;
};
